import { useCallback, useMemo } from 'react';

function useDiscountCalculator({ unitPriceForMoq, unitDiscountedPrice, totalListPrice, totalDiscountedPrice, vatInc }) {
  const getPrice = useCallback((price) => price?.[vatInc ? "taxed" : "untaxed"] || 0, [vatInc]);
  const discountedPercentage = useMemo(() => {
    if (!unitPriceForMoq || !unitDiscountedPrice) throw new Error("One or more required parameters are null or undefined: unitListPrice, unitDiscountedPrice.");
    const listPrice = getPrice(unitPriceForMoq);
    const discountedPrice = getPrice(unitDiscountedPrice);
    if (listPrice === 0) return 0;
    return Math.round((1 - discountedPrice / listPrice) * 100);
  }, [unitDiscountedPrice, unitPriceForMoq, getPrice]);
  const isDiscounted = useMemo(() => {
    const listPrice = getPrice(totalListPrice);
    const discountedPrice = getPrice(totalDiscountedPrice);
    return discountedPrice < listPrice;
  }, [totalListPrice, totalDiscountedPrice, getPrice]);
  return {
    discountedPercentage,
    isDiscounted
  };
}

export { useDiscountCalculator as default };
//# sourceMappingURL=ep-pricing-esm-hooks-useDiscountCalculator.js.map
